import clsx from 'clsx';

import { Button } from '@/components/button/button';
import Modal from '@/components/modal/modal';
import { Heading } from '@/components/typography/heading';

import styles from './SaveEditsModal.module.scss';


type SaveEditsModalProps = {
  agentName: string;
  agentVersion: number;
  hasErrors: boolean;
  onCancel: () => void;
  onClose: () => void;
  onSave: () => void;
};

export const SaveEditsModal = ( props: SaveEditsModalProps ) => {
  const {
    agentName,
    hasErrors,
    onCancel,
    onClose,
    onSave
  } = props;

  return (
    <Modal>
      <Heading as="h2" size="md">
        Save changes before closing?
      </Heading>
      <div className={ clsx( 'layout__row', 'pad' ) }>
        <p>
          { `You have unsaved changes to ${ agentName }.`}
        </p>
      </div>
      {
        hasErrors && (
          <div className={ clsx( 'layout__row', 'pad' ) }>
            <p className={ styles.error_message }>
              <strong>Cannot save:</strong> There are validation errors that must be fixed first. Please correct the invalid field names (shown in red).
            </p>
          </div>
        )
      }
      <div className={ clsx( 'layout__row', 'pad', 'flex_right' ) }>
        <Button variant="secondary" size="sm" onClick={ onCancel }>Cancel</Button>
        <Button variant="secondary" size="sm" onClick={ onClose }>Don't save</Button>
        <Button variant="primary" size="sm" onClick={ onSave } disabled={ hasErrors }>Save & close</Button>
      </div>
    </Modal>
  );
};
